<span
  *ngIf="label"
  class="status-label"
  [ngClass]="{ unknown: label.color.id == 'UNKNOWN' }"
  [ngStyle]="{ backgroundColor: label.color.bg, color: label.color.fg }"
  [matTooltip]="
    shouldCropLabel && label.name.length > croppedLength
      ? label.name
      : label.color.id == 'UNKNOWN' && !shouldHideUnknownTooltip
        ? ('actions.unknown_option' | translate)
        : null
  ">
  {{ shouldCropLabel && label.name.length > croppedLength ? (label.name | slice: 0 : croppedLength) + '...' : label.name }}

  <span *ngIf="label.color.id == 'UNKNOWN'" class="icon-Question"></span>
</span>
